function getElementText(element) {
  return (
    element.getAttribute('aria-label') ??
    (element.innerText ? element.innerText : undefined)
  );
}

export default getElementText;
